(function()
{
    //Import classes
    var BasePanel = include('springroll.easeljs.BasePanel'),
        Bitmap = include('createjs.Bitmap'),
        SoundButton = include('springroll.easeljs.SoundButton');

    /**
     * Panel contains all of the visual elements for the title state
     * @class WGBH.TitlePanel
     * @extends springroll.easeljs.BasePanel
     */
    var TitlePanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = extend(TitlePanel, BasePanel);

    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
        this.background = new Bitmap(images.TitleBackground);
        this.addChildAt(this.background, 0);

        this.playButton = new SoundButton(images.PlayButton);
        this.playButton.scaleX = 0.6;
        this.playButton.scaleY = 0.6;
        this.addChild(this.playButton);
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
        s.teardown.call(this);
        this.background = null;
        this.playButton = null;
    };

    //Assign to namespace
    namespace('WGBH').TitlePanel = TitlePanel;
}());